import { useEffect, useState } from "react";
import AuthService from "../../../../../../api/AuthService";
import EditNotesPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/EditNotes";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";

const EditNotes = () => {
    const [loading, setLoading] = useState(false);
    const [editNoteData, setEditNoteData] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const { showAlert } = useAlert();
    const navigate = useNavigate();

    useEffect(() => {
        getItem();
        getCustomerList();
    }, []);

    const getItem = async (text) => {
        setLoading(true);
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getItemsList(text);
            if (result?.success) {
                setItemList(result?.data?.items);
                LoaderHelper.loaderStatus(false);
            } else {
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            LoaderHelper.loaderStatus(false);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const getCustomerList = async (text, sort, page) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getCustomer(text, sort, page);
            if (result?.success) {
                setCustomerList(result?.data?.customers)
                LoaderHelper.loaderStatus(false);
            } else {
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            LoaderHelper.loaderStatus(false);
        }
    };
    const getEditNotesData = async (id) => {
        LoaderHelper.loaderStatus(true);
        setLoading(true)
        try {
            const result = await AuthService.getEditNotesData(id);
            setEditNoteData(result?.data);
            if (result?.success === true) {
                setLoading(false)
                LoaderHelper.loaderStatus(false);
            } else {
                setLoading(false)
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            setLoading(false)
            LoaderHelper.loaderStatus(false);
        }
    };

    const updateNotes = async (payload, id) => {
        LoaderHelper.loaderStatus(true);
        setLoading(true);
        try {
            const result = await AuthService.updateNotes({ id, payload });
            if (result?.success) {
                setLoading(false);
                LoaderHelper.loaderStatus(false);
                showAlert(result?.message, "success");
                navigate("/dashboard/notesHome");
                getItem();
            } else {
                setLoading(false);
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            setLoading(false);
            LoaderHelper.loaderStatus(false);
        }
    }

    return (
        <>
            <EditNotesPage customerList={customerList} itemList={itemList} getEditNotesData={getEditNotesData} editNoteData={editNoteData} updateNotes={updateNotes} loading={loading} />
        </>
    );
};
export default EditNotes;